export const ORDER_PAGES = {
    connecting: 'connecting',
    success: 'success',
    failed: 'failed',
    canceled: 'canceled',
    error: 'error',
    refund: 'refund',
} as const;

export const ORDER_ROUTES = {
    connecting: `/:id/${ORDER_PAGES.connecting}`,
    success: `/:id/${ORDER_PAGES.success}`,
    failed: `/:id/${ORDER_PAGES.failed}`,
    canceled: `/:id/${ORDER_PAGES.canceled}`,
    error: `/:id/${ORDER_PAGES.error}`,
    refund: `/:id/${ORDER_PAGES.refund}`,
} as const;
